import React, { useState, useEffect } from "react";
import img1 from "../assets/images/analytic3.png";
import img2 from "../assets/images/analyticPic2.png";
import img3 from "../assets/images/datAnalytic2.png";

export default function ImageSliderComponent() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [img1, img2, img3];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev =>
        prev === images.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <div
      style={{
        backgroundColor: "#2C577D",
        flex: 1,
        padding: "20px",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          maxWidth: "700px"
        }}
      >
        {/* Left shadow */}
        <div
          style={{
            position: "absolute",
            top: "15px",
            left: "-20px",
            width: "100%",
            height: "100%",
            backgroundColor: "#d1dce6",
            borderRadius: "20px",
            zIndex: 0,
            display: window.innerWidth < 768 ? "none" : "block"
          }}
        />

        {/* Bottom shadow */}
        <div
          style={{
            position: "absolute",
            top: "20px",
            left: "0",
            width: "100%",
            height: "100%",
            backgroundColor: "#d1dce6",
            borderRadius: "20px",
            zIndex: 0,
            display: window.innerWidth < 768 ? "none" : "block"
          }}
        />

        {/* Main card */}
        <div
          style={{
            position: "relative",
            width: "100%",
            minWidth: window.innerWidth < 768 ? "auto" : "500px",
            minHeight: window.innerWidth < 768 ? "400px" : "500px",
            borderRadius: "20px",
            // border: "3px solid #4a90e2",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            overflow: "hidden",
            backgroundColor: "#fff",
            zIndex: 1
          }}
        >
          {/* Image slider (FULL HEIGHT) */}
          <div
            style={{
              position: "absolute",
              inset: 0
            }}
          >
            {images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Slide ${index + 1}`}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  opacity: currentIndex === index ? 1 : 0,
                  transition: "opacity 0.5s ease-in-out"
                }}
              />
            ))}
          </div>

          {/* Pagination dots OVER IMAGE */}
          <div
            style={{
              position: "absolute",
              bottom: "16px",
              left: 0,
              right: 0,
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              zIndex: 2
            }}
          >
            {images.map((_, index) => (
              <div
                key={index}
                onClick={() => goToSlide(index)}
                style={{
                  width: window.innerWidth < 768 ? "8px" : "10px",
                  height: window.innerWidth < 768 ? "8px" : "10px",
                  borderRadius: "50%",
                  backgroundColor:
                    currentIndex === index ? "#4299e1" : "#cbd5e0",
                  cursor: "pointer",
                  transition: "background-color 0.3s ease"
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
